module.exports = __webpack_public_path__ + "img/xiaomi12tkvmobilna.99145377.png";